import {toISODate, toDecimal, formatDateBr} from "../../utils/convert-fields"

export const mapEventosExtraordinariosToRows = (apiData = []) => {
    if (!apiData || apiData.length === 0) return [{}]

    return apiData.map(item => ({
        id: item.ID ?? `${Date.now()}-${Math.random()}`,
        _serverID: item.ID ?? null,
        dataReferencia: formatDateBr(item.DataReferencia),
        dataEvento: formatDateBr(item.DataEvento),
        dataLiquidacao: formatDateBr(item.DataLiquidacao),
        tipoEvento: item.TipoEvento || "",
        valorPercentual: item.ValorPercentual ?? "",
        valorFinanceiro: item.ValorFinanceiro ?? "",
        fonte: item.Fonte || "",
    }))
}

const DATA_FIELDS = [
    "dataReferencia", "dataEvento", "dataLiquidacao",
    "tipoEvento", "valorPercentual", "valorFinanceiro", "fonte",
]

export const mapRowsToEventosExtraordinariosPayload = (rows = [], cetip = "") => {
    return rows
        .filter(row =>
            row &&
            DATA_FIELDS.some(field => {
                const v = row[field]
                return v !== "" && v !== null && v !== undefined
            })
        )
        .map(row => ({
            CETIP: cetip,
            DataReferencia: toISODate(row.dataReferencia),
            DataEvento: toISODate(row.dataEvento),
            DataLiquidacao: toISODate(row.dataLiquidacao),
            TipoEvento: row.tipoEvento || null,
            ValorPercentual: toDecimal(row.valorPercentual) ?? null,
            ValorFinanceiro: toDecimal(row.valorFinanceiro) ?? null,
            Fonte: row.fonte || null,
        }))
}
